const addSecurity = (spec: any) => {
  // Authorization Header 확인 및 제거
  const filterAuthorizationParameters = (data: any) => {
    const filteredParameters: any[] = [];
    let hasAuthorization = false;
    let hasSystemKey = false;

    if (!data.parameters) {
      return { filteredParameters, hasAuthorization, hasSystemKey };
    }

    for (const param of data.parameters) {
      if (param.name === 'Authorization') {
        hasAuthorization = true;
      } else if (param.name === 'systemKey') {
        hasSystemKey = true;
      } else {
        filteredParameters.push(param);
      }
    }

    return { filteredParameters, hasAuthorization, hasSystemKey };
  };

  function getSecurityDescription(spec: any) {
    let authorizationDescription = '';
    let systemKeyDescription = '';

    // Paths 순회
    for (const path of Object.keys(spec.paths)) {
      if (authorizationDescription != '' && systemKeyDescription != '') break;

      for (const method of Object.keys(spec.paths[path])) {
        const data = spec.paths[path][method];
        if (!data.parameters || (authorizationDescription != '' && systemKeyDescription != '')) break;

        for (const param of data.parameters) {
          if (param.name === 'Authorization' && param.description) {
            authorizationDescription = param.description.replace();
          } else if (param.name === 'systemKey' && param.description) {
            systemKeyDescription = param.description;
          }
        }
      }
    }

    return { authorizationDescription, systemKeyDescription };
  }

  // Security Scheme 필드 추가
  let { authorizationDescription, systemKeyDescription } = getSecurityDescription(spec);
  spec.components = {
    securitySchemes: {
      Authorization: { type: 'http', scheme: 'bearer', bearerFormat: 'JWT', description: authorizationDescription },
      systemKey: { type: 'apiKey', in: 'header', name: 'systemKey', description: systemKeyDescription },
    },
    ...spec.components,
  };

  // Paths 순회
  for (const path of Object.keys(spec.paths)) {
    for (const method of Object.keys(spec.paths[path])) {
      const data = spec.paths[path][method];
      const { filteredParameters, hasAuthorization, hasSystemKey } = filterAuthorizationParameters(data);
      console.log(hasAuthorization, hasSystemKey);

      spec.paths[path][method].parameters = filteredParameters;

      const security = [];
      if (hasAuthorization) {
        security.push({ Authorization: [] });
      }
      if (hasSystemKey) {
        security.push({ systemKey: [] });
      }

      if (security.length > 0) {
        spec.paths[path][method].security = security;
      }
    }
  }

  return spec;
};

export default addSecurity;
